/** @jsx jsx */
import { jsx } from '@emotion/core'
import { FormProps } from 'components/form'
import { useMemo, useRef } from 'react'
import { useParams } from 'react-router'
import { setDifference } from 'types/extensions/set-extensions'
import { emptyArray } from 'util/array'
import { CidadaoAtendimento } from 'view/atendimentos/types/CidadaoAtendimento'

import { SolicitacaoExameModel } from './model-solicitacaoExames'
import SolicitarExamesFormModal, { SolicitarExamesUrlParams } from './SolicitarExamesFormModal'

interface SolicitarExamesEditarModalProps extends Omit<FormProps<SolicitacaoExameModel>, 'initialValues' | 'render'> {
  cidadao: CidadaoAtendimento
  adicionados: SolicitacaoExameModel[]
  idsExmAdicionadosAtend: Set<ID>
  iniciadoEm: Instant
  onClose(): void
}

export default function SolicitarExamesEditarModal(props: Readonly<SolicitarExamesEditarModalProps>) {
  const { cidadao, onSubmit, onClose, adicionados = emptyArray, idsExmAdicionadosAtend, iniciadoEm } = props
  const { id } = useParams<SolicitarExamesUrlParams>()

  const initialValues = useRef<SolicitacaoExameModel>(adicionados?.find((item) => item._id === id))

  const idsExmAdicionadosAtendDif = useMemo(() => {
    return idsExmAdicionadosAtend
      ? setDifference(
          idsExmAdicionadosAtend,
          new Set<ID>(initialValues.current?.examesSolicitados?.map((ex) => ex.exame.id))
        )
      : new Set<ID>()
  }, [idsExmAdicionadosAtend])

  return (
    <SolicitarExamesFormModal
      cidadao={cidadao}
      editing={true}
      initialValues={initialValues.current}
      idsExmAdicionadosAtend={idsExmAdicionadosAtendDif}
      iniciadoEm={iniciadoEm}
      onSubmit={onSubmit}
      onClose={onClose}
    />
  )
}
